/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-api
 * crm-screener-api
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { OrganizationState } from './OrganizationState';
import {
    OrganizationStateFromJSON,
    OrganizationStateFromJSONTyped,
    OrganizationStateToJSON,
} from './OrganizationState';

/**
 * 
 * @export
 * @interface CreateOrganizationState201Response
 */
export interface CreateOrganizationState201Response {
    /**
     * 
     * @type {OrganizationState}
     * @memberof CreateOrganizationState201Response
     */
    data?: OrganizationState;
}

/**
 * Check if a given object implements the CreateOrganizationState201Response interface.
 */
export function instanceOfCreateOrganizationState201Response(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function CreateOrganizationState201ResponseFromJSON(json: any): CreateOrganizationState201Response {
    return CreateOrganizationState201ResponseFromJSONTyped(json, false);
}

export function CreateOrganizationState201ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateOrganizationState201Response {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'data': !exists(json, 'data') ? undefined : OrganizationStateFromJSON(json['data']),
    };
}

export function CreateOrganizationState201ResponseToJSON(value?: CreateOrganizationState201Response | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'data': OrganizationStateToJSON(value.data),
    };
}

